import { nextTick, ref } from 'vue';

const activeElement = ref<HTMLElement | null>(null);

export const useElementFocus = () => {
    const rememberFocus = () => {
        const currentActiveElement = document.activeElement as HTMLElement | null;

        if (currentActiveElement) {
            activeElement.value = currentActiveElement;
        }
    };

    const setFocus = (
        element: string | HTMLElement | null,
        fallbackElement: string | HTMLElement | null = null
    ) => {
        nextTick(() => {
            rememberFocus();

            const nextElement =
                typeof element === 'string'
                    ? document.querySelector<HTMLElement>(element)
                    : element;

            if (nextElement) {
                nextElement.focus();
            } else if (fallbackElement) {
                const fallback =
                    typeof fallbackElement === 'string'
                        ? document.querySelector<HTMLElement>(fallbackElement)
                        : fallbackElement;

                if (fallback) {
                    fallback.focus();
                }
            }
        });
    };

    const restoreFocus = () => {
        if (activeElement.value) {
            setFocus(activeElement.value);
            activeElement.value = null;
        }
    };

    return { setFocus, rememberFocus, restoreFocus };
};
